(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

/* DD image protection — discourages casual saving without blocking image links or galleries. */
(function protectDisplayedImages() {
  const style = document.createElement('style');
  style.textContent = 'img{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;-webkit-user-drag:none}';
  document.head.appendChild(style);

  function isImageTarget(target) {
    return target instanceof HTMLImageElement;
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (isImageTarget(event.target)) event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (isImageTarget(event.target)) event.preventDefault();
    },
    true
  );
})();
